var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "aria-current": "location",
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('partner.partner_area', '合作夥伴專區')) + " ")]), _c('b-breadcrumb-item', {
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('partner.partner_management', "合作夥伴管理")) + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? _vm.displayText('partner.view_partner', '查看合作夥伴') : _vm.isEditing ? _vm.displayText('partner.edit_partner', '編輯合作夥伴') : _vm.displayText('partner.add_partner', '新增合作夥伴')) + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? _vm.displayText('partner.view_partner', '查看合作夥伴') : _vm.isEditing ? _vm.displayText('partner.edit_partner', '編輯合作夥伴') : _vm.displayText('partner.add_partner', '新增合作夥伴')) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": '*' + _vm.displayText('partner.name', '名稱')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.partner.name.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.name,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "name", $$v);
      },
      expression: "partner.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.partner.name.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('partner.is_required', '此欄位為必填')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": '*' + _vm.displayText('partner.partner_code', '夥伴代碼')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.partner.partner_code.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.partner_code,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "partner_code", $$v);
      },
      expression: "partner.partner_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.partner.partner_code.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('partner.is_required', '此欄位為必填')) + " ")])], 1), _vm.hiddenField('outer_code') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.outer_code', '外部代碼')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "outer_code", $$v);
      },
      expression: "partner.outer_code"
    }
  })], 1) : _vm._e(), _vm.hiddenField('avatar') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.avatar', '個人頭像')
    }
  }, [_vm.image || _vm.partner.logo_url ? _c('li', {
    staticClass: "s-image-list-item s-draggable"
  }, [_c('img', {
    staticClass: "s-cropped-image",
    attrs: {
      "src": _vm.image || _vm.partner.logo_url
    }
  }), !_vm.isReadOnly ? _c('button', {
    staticClass: "btn btn-danger s-delete-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.deleteImage();
      }
    }
  }, [_vm._v("Ｘ")]) : _vm._e()]) : _c('li', {
    staticClass: "s-image-list-item"
  }, [!_vm.isReadOnly ? _c('ImageSelector', {
    on: {
      "input": _vm.selectImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          on: {
            "click": openFileSelector
          }
        }, [_vm._v("＋ " + _vm._s(_vm.displayText('partner.add_avatar', '新增頭像')) + "}")])];
      }
    }], null, false, 2314743348)
  }) : _vm._e()], 1)]) : _vm._e(), _vm.hiddenField('order') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.order', '順序')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.order,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "order", $$v);
      },
      expression: "partner.order"
    }
  })], 1) : _vm._e(), _vm.hiddenField('telephone') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.phone', '電話')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "telephone", $$v);
      },
      expression: "partner.telephone"
    }
  })], 1) : _vm._e(), _vm.hiddenField('fax') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.fax', '傳真')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.fax,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "fax", $$v);
      },
      expression: "partner.fax"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "city-selector-set-has-value",
    attrs: {
      "data-has-zipcode": ""
    }
  }, [_vm.hiddenField('city') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.city', '城市')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.partner.city,
      expression: "partner.city"
    }],
    staticClass: "form-control form-control-sm county",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.partner, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  })]) : _vm._e(), _c('b-form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hiddenField('district'),
      expression: "hiddenField('district')"
    }],
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.district', '鄉鎮市')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.partner.district,
      expression: "partner.district"
    }],
    staticClass: "form-control form-control-sm district",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.partner, "district", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.handleChangeZipcode]
    }
  })]), _c('b-form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hiddenField('district') && _vm.hiddenField('zipcode'),
      expression: "hiddenField('district') && hiddenField('zipcode')"
    }],
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.zipcode', '郵遞區號')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 zipcode",
    attrs: {
      "type": "text",
      "placeholder": _vm.displayText('partner.zipcode', '郵遞區號'),
      "readonly": ""
    },
    model: {
      value: _vm.partner.zipcode,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "zipcode", $$v);
      },
      expression: "partner.zipcode"
    }
  })], 1)], 1), _vm.hiddenField('address') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.address', '地址')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.address,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "address", $$v);
      },
      expression: "partner.address"
    }
  })], 1) : _vm._e(), _vm.hiddenField('is_enabled') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.is_enabled', '是否啟用')
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.partner.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "is_enabled", $$v);
      },
      expression: "partner.is_enabled"
    }
  })], 1) : _vm._e(), _vm.hiddenField('status') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.partner_status', '狀態')
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.isReadOnly,
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.partner.status,
      callback: function callback($$v) {
        _vm.$set(_vm.partner, "status", $$v);
      },
      expression: "partner.status"
    }
  })], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }